<template>
    <div
        class="tvPlayer"
        :class="{
            'tvPlayer--touch': isTouchDevice,
            'tvPlayer--fullscreen': isFullScreenOpen,
            'tvPlayer--leftpanelClosed': !isLeftPanelOpen,
        }"
        ref="tvPlayerRef"
        @mousemove="showControls"
        @mouseleave="hideControls"
        @click="showControls"
    >
        <div class="tvPlayer__wrapper">
            <div
                class="tvPlayer__controls"
                :class="{
                    'tvPlayer__controls--active': controlsVisible,
                    'tvPlayer__controls--touch': isTouchDevice,
                }"
            >
                <div class="tvPlayer__controls__wrapper">
                    <div class="tvPlayer__controls_top">
                        <div class="channel">
                            <div class="channel__item">
                                <div
                                    class="channel__item_img"
                                    v-if="currentItem?.icon"
                                >
                                    <div class="channel__item_img_content">
                                        <img
                                            :src="currentItem?.icon"
                                            :alt="currentItem?.name"
                                        />
                                    </div>
                                </div>
                                <div class="channel__item_content">
                                    <h1 class="channel__item_content_title">
                                        {{ currentItem?.name }}
                                    </h1>
                                    <h2
                                        v-if="currentPrograName"
                                        class="channel__item_content_subtitle"
                                    >
                                        {{ currentPrograName }}
                                    </h2>
                                </div>
                            </div>
                        </div>
                        <div
                            class="tvPlayer__controls_top_right"
                            v-if="currentItem"
                        >
                            <button
                                v-if="currentProgramTime"
                                class="tvPlayer__controls_top_right_btn"
                                :class="{
                                    'tvPlayer__controls_top_right_btn--active':
                                        isLiked,
                                }"
                                :title="
                                    isLiked
                                        ? `${$t(
                                              'message.tvChannel.removeFromFavorite'
                                          )} (a)`
                                        : `${$t(
                                              'message.tvChannel.addToFavorite'
                                          )} (a)`
                                "
                                :aria-label="
                                    isLiked
                                        ? $t(
                                              'message.tvChannel.removeFromFavorite'
                                          )
                                        : $t('message.tvChannel.addToFavorite')
                                "
                                @click.stop="toggleLike(currentItem)"
                            >
                                <iFav />
                            </button>
                            <button
                                class="tvPlayer__controls_top_right_btn tvPlayer__controls_top_right_btn_close"
                                title="close"
                                aria-label="close"
                                v-if="!currentProgramTime"
                                @click.stop="goBack"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        fill="#fff"
                                        d="m12 13.4l-4.9 4.9q-.275.275-.7.275t-.7-.275t-.275-.7t.275-.7l4.9-4.9l-4.9-4.9q-.275-.275-.275-.7t.275-.7t.7-.275t.7.275l4.9 4.9l4.9-4.9q.275-.275.7-.275t.7.275t.275.7t-.275.7L13.4 12l4.9 4.9q.275.275.275.7t-.275.7t-.7.275t-.7-.275z"
                                    />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div
                        class="tvPlayer__controls_center"
                        @click.stop="togglePlayFromVideo"
                    >
                        <button
                            aria-label="Prev"
                            class="controls__icon controls__icon--touch controls__icon--prev"
                            @click.stop="
                                currentProgramTime ? nextChannel() : prevTime()
                            "
                            :title="`${$t(
                                'message.tvChannel.prevChannel'
                            )} (\u2191)`"
                            :aria-label="`${$t(
                                'message.tvChannel.prevChannel'
                            )} (\u2191)`"
                        >
                            <IPrev />
                        </button>
                        <button
                            aria-label="Next"
                            @click.stop="togglePlay"
                            class="controls__icon controls__icon--touch controls__icon--play"
                            :title="
                                isPlaying
                                    ? `${$t('message.tvChannel.pause')} (Space)`
                                    : `${$t('message.tvChannel.play')} (Space)`
                            "
                            :aria-label="
                                isPlaying
                                    ? $t('message.tvChannel.pause')
                                    : $t('message.tvChannel.play')
                            "
                        >
                            <IPlay v-if="!isPlaying" />
                            <IPause v-else />
                        </button>
                        <button
                            aria-label="Play"
                            class="controls__icon controls__icon--touch controls__icon--next"
                            @click.stop="
                                currentProgramTime ? prevChannel() : nextTime()
                            "
                            :title="`${$t(
                                'message.tvChannel.nextChannel'
                            )} (\u2193)`"
                            :aria-label="`${$t(
                                'message.tvChannel.nextChannel'
                            )} (\u2193)`"
                        >
                            <INext />
                        </button>
                    </div>
                    <div class="tvPlayer__controls_bottom">
                        <div class="tvPlayer__controls_bottom_top">
                            <ElButton
                                size="small"
                                :type="isLive ? 'default' : 'grey'"
                                @click.stop="liveToggle"
                                :disabled="isLive"
                                :attrs="{
                                    title: isLive
                                        ? `${$t(
                                              'message.tvChannel.isLive'
                                          )} (L)`
                                        : `${$t(
                                              'message.tvChannel.goToLive'
                                          )} (L)`,
                                    class: 'toggleLive',
                                }"
                                v-if="currentProgramTime"
                            >
                                {{
                                    isLive
                                        ? $t("message.tvChannel.isLive")
                                        : $t("message.tvChannel.goToLive")
                                }}
                                <span></span>
                            </ElButton>
                        </div>
                        <div class="tvPlayer__controls_bottom_center">
                            <div class="timeLine" v-if="currentProgramTime">
                                <div class="timeLine__time">
                                    <div class="timeLine__time_item">
                                        {{ programTime?.beginTime }}
                                    </div>
                                    <div class="timeLine__time_item">
                                        {{ programTime?.endTime }}
                                    </div>
                                </div>
                                <div class="timeLine__line">
                                    <input
                                        type="range"
                                        class="timeLine__line_range rengeInput"
                                        :min="currentProgramTime?.beginTime"
                                        :max="currentProgramTime?.endTime"
                                        :value="liveTime"
                                        aria-label="timeLine__line_range"
                                        :style="{
                                            '--value':
                                                ((liveTime -
                                                    currentProgramTime?.beginTime) /
                                                    (currentProgramTime?.endTime -
                                                        currentProgramTime?.beginTime)) *
                                                    100 +
                                                '%',
                                        }"
                                        id="myRange"
                                        tabindex="-1"
                                        @change="
                                            seekVideoHandler(
                                                $event.target.value
                                            )
                                        "
                                        @touchmove="showControlsPrevent"
                                        @click="showControlsPrevent"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="tvPlayer__controls_bottom_bottom">
                            <div class="controls">
                                <div class="controls__left">
                                    <button
                                        aria-label="Prev"
                                        class="controls__icon controls__icon--desctop controls__icon--prev"
                                        @click.stop="nextChannel"
                                        :title="`${$t(
                                            'message.tvChannel.prevChannel'
                                        )} (\u2191)`"
                                        :aria-label="`${$t(
                                            'message.tvChannel.prevChannel'
                                        )} (\u2191)`"
                                        v-if="currentProgramTime"
                                    >
                                        <IPrev />
                                    </button>
                                    <button
                                        aria-label="Next"
                                        @click.stop="togglePlay"
                                        class="controls__icon controls__icon--desctop controls__icon--play"
                                        :title="
                                            isPlaying
                                                ? `${$t(
                                                      'message.tvChannel.pause'
                                                  )} (Space)`
                                                : `${$t(
                                                      'message.tvChannel.play'
                                                  )} (Space)`
                                        "
                                        :aria-label="
                                            isPlaying
                                                ? $t('message.tvChannel.pause')
                                                : $t('message.tvChannel.play')
                                        "
                                        v-if="currentProgramTime"
                                    >
                                        <IPlay v-if="!isPlaying" />
                                        <IPause v-else />
                                    </button>
                                    <button
                                        aria-label="Play"
                                        class="controls__icon controls__icon--desctop controls__icon--next"
                                        @click.stop="prevChannel"
                                        :title="`${$t(
                                            'message.tvChannel.nextChannel'
                                        )} (\u2193)`"
                                        :aria-label="`${$t(
                                            'message.tvChannel.nextChannel'
                                        )} (\u2193)`"
                                        v-if="currentProgramTime"
                                    >
                                        <INext />
                                    </button>
                                    <div class="volume">
                                        <button
                                            class="controls__icon controls__icon--volume"
                                            @click.stop="toggleMuted"
                                            :title="
                                                muted
                                                    ? `${$t(
                                                          'message.tvChannel.unmute'
                                                      )} (M)`
                                                    : `${$t(
                                                          'message.tvChannel.mute'
                                                      )} (M)`
                                            "
                                            :aria-label="
                                                muted
                                                    ? $t(
                                                          'message.tvChannel.unmute'
                                                      )
                                                    : $t(
                                                          'message.tvChannel.mute'
                                                      )
                                            "
                                        >
                                            <iVolume v-if="!muted" />
                                            <IMuted v-else />
                                        </button>
                                        <div class="volume__range">
                                            <input
                                                type="range"
                                                class="volume__range_input rengeInput"
                                                min="0"
                                                max="100"
                                                aria-label="Volume"
                                                :value="volume"
                                                :style="{
                                                    '--value': volume + '%',
                                                }"
                                                tabindex="-1"
                                                @input.stop="
                                                    changeVolume($event)
                                                "
                                                @click="showControlsPrevent"
                                            />
                                        </div>
                                    </div>
                                    <ElButton
                                        size="small"
                                        :type="isLive ? 'default' : 'grey'"
                                        @click.stop="liveToggle"
                                        :disabled="isLive"
                                        :attrs="{
                                            title: isLive
                                                ? `${$t(
                                                      'message.tvChannel.isLive'
                                                  )} (L)`
                                                : `${$t(
                                                      'message.tvChannel.goToLive'
                                                  )} (L)`,
                                            class: 'liveToggleTouch toggleLive',
                                        }"
                                        v-if="currentProgramTime"
                                    >
                                        {{
                                            isLive
                                                ? $t("message.tvChannel.isLive")
                                                : $t(
                                                      "message.tvChannel.goToLive"
                                                  )
                                        }}
                                        <span></span>
                                    </ElButton>
                                </div>
                                <div class="controls__center">
                                    <div
                                        class="laftPanelControl"
                                        v-if="currentProgramTime"
                                    >
                                        <button
                                            class="laftPanelControl__item"
                                            :class="{
                                                'laftPanelControl__item--disabled':
                                                    item.id == 2
                                                        ? getIsLoadingEpg
                                                        : false,
                                            }"
                                            v-for="item in headLinks"
                                            :key="item.id"
                                            @click.stop="
                                                toggleTvprogram(item.id)
                                            "
                                            :title="`${item.title} ${
                                                item.id == 1 ? ' (p)' : ' (t)'
                                            }`"
                                        >
                                            <template
                                                v-if="
                                                    isLoggedIn
                                                        ? true
                                                        : item.id == 1
                                                "
                                            >
                                                <div
                                                    class="controls__icon controls__icon--laftPanelControl"
                                                >
                                                    <ITv v-if="item.id === 1" />
                                                    <IProgram
                                                        v-if="item.id === 2"
                                                    />
                                                </div>
                                                <span
                                                    class="laftPanelControl__item_programTitle"
                                                    >{{ item.title }}</span
                                                >
                                            </template>
                                        </button>
                                    </div>
                                    <div
                                        class="controls__center_videoControls"
                                        v-if="!currentProgramTime"
                                    >
                                        <button
                                            aria-label="Prev"
                                            class="controls__icon controls__icon--desctop controls__icon--prev"
                                            @click.stop="prevTime"
                                            :title="`-10 (\u2190)`"
                                            :aria-label="`-10 (\u2190)`"
                                        >
                                            <IPrev />
                                        </button>
                                        <button
                                            aria-label="Next"
                                            @click.stop="togglePlay"
                                            class="controls__icon controls__icon--desctop controls__icon--play"
                                            :title="
                                                isPlaying
                                                    ? `${$t(
                                                          'message.tvChannel.pause'
                                                      )} (Space)`
                                                    : `${$t(
                                                          'message.tvChannel.play'
                                                      )} (Space)`
                                            "
                                            :aria-label="
                                                isPlaying
                                                    ? $t(
                                                          'message.tvChannel.pause'
                                                      )
                                                    : $t(
                                                          'message.tvChannel.play'
                                                      )
                                            "
                                        >
                                            <IPlay v-if="!isPlaying" />
                                            <IPause v-else />
                                        </button>
                                        <button
                                            aria-label="Play"
                                            class="controls__icon controls__icon--desctop controls__icon--next"
                                            @click.stop="nextTime"
                                            :title="`'+10'(\u2192)`"
                                            :aria-label="`'+10' (\u2192)`"
                                        >
                                            <INext />
                                        </button>
                                    </div>
                                </div>
                                <div class="controls__right">
                                    <div
                                        class="controls__icon controls__icon--settings"
                                        @click.stop="openTvModalModal(tvModal)"
                                    >
                                        <div
                                            class="controls__icon controls__icon--settings"
                                            :title="`${$t(
                                                'message.tvChannel.settings'
                                            )} (S)`"
                                        >
                                            <ISettings />
                                        </div>
                                        <div
                                            class="tvModal"
                                            v-if="isTvModalOpen"
                                        >
                                            <div class="tvModal__container">
                                                <div class="tvModal__wrapper">
                                                    <div class="tvModal__head">
                                                        <span
                                                            class="controls__icon controls__icon--back"
                                                            v-if="
                                                                canTvModalGoBack
                                                            "
                                                        >
                                                            <IBack />
                                                        </span>
                                                        <span
                                                            class="controls__icon controls__icon--back"
                                                            v-if="
                                                                currentTvModalData.type ===
                                                                'settings'
                                                            "
                                                        >
                                                            <ISettings />
                                                        </span>
                                                        {{
                                                            $i18n.locale ===
                                                            "ru"
                                                                ? currentTvModalData.title_ru
                                                                : currentTvModalData.title_uz
                                                        }}
                                                        <span
                                                            v-if="
                                                                currentTvModalData.type ===
                                                                'language'
                                                            "
                                                        >
                                                            (
                                                            {{
                                                                checkLangname(
                                                                    currentAudioTrack
                                                                )
                                                            }}
                                                            )
                                                        </span>
                                                    </div>
                                                    <div class="tvModal__list">
                                                        <div
                                                            class="tvModal__list_item"
                                                            v-for="item in currentTvModalData.list"
                                                            :key="item.id"
                                                            @click.stop="
                                                                openTvModalItem(
                                                                    item
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                $i18n.locale ===
                                                                "ru"
                                                                    ? item.title_ru
                                                                    : item.title_uz
                                                            }}
                                                            <span
                                                                v-if="
                                                                    item.type ===
                                                                    'language'
                                                                "
                                                            >
                                                                (
                                                                {{
                                                                    checkLangname(
                                                                        currentAudioTrack
                                                                    )
                                                                }}
                                                                )
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <button
                                        class="controls__icon"
                                        @click.stop="toggleWindow"
                                        :title="`${$t(
                                            'message.tvChannel.pip'
                                        )} (k)`"
                                        :aria-label="`${$t(
                                            'message.tvChannel.pip'
                                        )} (k)`"
                                    >
                                        <ISmallWindow />
                                    </button>
                                    <button
                                        class="controls__icon"
                                        @click.stop="toggleFullScreen"
                                        :title="`${$t(
                                            'message.tvChannel.fullScreen'
                                        )} (F)`"
                                        :aria-label="`${$t(
                                            'message.tvChannel.fullScreen'
                                        )} (F)`"
                                    >
                                        <IFullScreen />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tvPlayer__video">
                <video
                    @play="videoPlayHandler"
                    @pause="videoPauseHandler"
                    @timeupdate="videTimeUpdateHandler"
                    src=""
                    tabindex="0"
                    ref="videoRef"
                    class="tvPlayer__video_item"
                    playsinline
                    autoplay
                ></video>
            </div>
            <div
                class="tvPlayer__succesModal"
                :class="{
                    'tvPlayer__succesModal--active': isProblemSended,
                    'tvPlayer__succesModal--activated': isProblemWasSended,
                }"
            >
                <div class="tvPlayer__succesModal_wrapper">
                    <div class="tvPlayer__succesModal_icon">
                        <ISucces />
                    </div>
                    <div class="tvPlayer__succesModal_title">
                        {{ $t("message.thanksForComplain") }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import iFav from "../Tv/icons/iFav.vue";
import ElButton from "../ElButton/index.vue";
import IPrev from "./icons/IPrev.vue";
import INext from "./icons/INext.vue";
import IPlay from "./icons/IPlay.vue";
import ITv from "./icons/ITv.vue";
import IProgram from "./icons/IProgram.vue";
import IVolume from "./icons/IVolume.vue";
import IFullScreen from "./icons/IFullScreen.vue";
import ISmallWindow from "./icons/ISmallWindow.vue";
import ISettings from "./icons/ISettings.vue";
import IPause from "./icons/IPause.vue";
import IMuted from "./icons/IMuted.vue";
import IBack from "./icons/IBack.vue";
import ISucces from "./icons/ISucces.vue";
import { mapGetters, mapActions } from "vuex";
import { converter } from "../../converter";
import { favouriteChannel } from "../../Api";
import Hls from "hls.js";
export default {
    name: "NewHtlTvPlayer",
    components: {
        iFav,
        ElButton,
        IPrev,
        INext,
        IPlay,
        IProgram,
        ITv,
        IVolume,
        IFullScreen,
        ISmallWindow,
        ISettings,
        IPause,
        IMuted,
        IBack,
        ISucces,
    },
    props: [
        "headLinks",
        "isLoggedIn",
        "hlsSource",
        "currentProgramTime",
        "currentItem",
        "notAcces",
        "forProblemsInfo",
        "epg",
        "timeDate",
        "isFullScreenOpen",
        "isLeftPanelOpen",
    ],
    emits: [
        "toggleTvprogram",
        "toggleFullScreen",
        "getLive",
        "liveIsStoped",
        "currentProgramTime",
        "seekVideo",
        "nextProgram",
        "prevTime",
        "nextTime",
        "prevChannel",
        "nextChannel",
        "closeLeftPanel",
    ],
    data() {
        return {
            hlsInstance: null,
            errorHlsCount: 0,
            startPTS: null,
            stopedTime: 0,
            startTimeforElapsed: 0,
            programTime: {},
            lastUpdateTime: 0,
            // playing
            isPlaying: false,
            isLive: true,
            liveTime: +(Date.now() / 1000).toFixed(),
            lastUpdateTime: 0,
            isPlayStarted: false,
            // playing
            controlsVisible: true,
            hideControlsTimeout: null,
            hideControlsDelay: 3000,
            clickCount: 0,
            volume: 100,
            muted: false,
            isLiked: 0,
            tvModal: {
                title_ru: "Настройки",
                title_uz: "Sozlamalar",
                type: "settings",
                list: [],
            },
            tvModalStack: [],
            currentAudioTrack: null,
            isProblemSended: false,
            isProblemSendedInteval: null,
            isProblemWasSended: false,
            currentPrograName: null,
            streamhub: null,
            firstPlay: true,
            userAgent: navigator.userAgent.match(/(android|iphone)/gi)?.[0],
        };
    },
    watch: {
        hlsSource(newVal, oldVal) {
            this.loadHls(newVal);
        },
        isPlaying(newVal) {
            if (newVal) {
                if (!this.isPlayStarted) {
                    this.isPlayStarted = true;
                    this.isLive = true;
                    this.liveTime = +(Date.now() / 1000).toFixed();
                    return;
                }
                this.$emit("liveIsStoped", this.stopedTime);
            } else {
                this.isLive = false;
            }
        },
        currentProgramTime(value) {
            if (!value) return;
            const { beginTime, endTime } = value;
            const currentTimeSeconds = +(Date.now() / 1000).toFixed();
            const time = {
                beginTime: converter(Number(currentTimeSeconds)).toString(),
                endTime: converter(Number(endTime)).toString(),
            };

            this.programTime = time;

            if (endTime > currentTimeSeconds) {
                this.isLive = true;
                this.liveTime = +currentTimeSeconds;
            }

            if (endTime < currentTimeSeconds) {
                this.isLive = false;
                this.liveTime = +beginTime;
            }
        },
        currentItem: {
            handler(val) {
                if (val) {
                    this.isLiked = val.is_favorited;
                }
            },
            deep: true,
        },
        complains(val) {
            if (val) {
                const complainsObj = {
                    title_ru: "Пожаловаться",
                    title_uz: "Shikoyat qilish",
                    type: "complains",
                    list: val.map((item) => {
                        return {
                            title_ru: item.title,
                            title_uz: item.title_uz,
                            type: "complain_inner",
                            id: item.id,
                        };
                    }),
                };
                this.tvModal.list.push(complainsObj);
            }
        },
        $route() {
            this.showControls();
        },
        timeDate() {
            this.selectedProgram();
        },
    },
    computed: {
        ...mapGetters(["getIsLoadingEpg", "complains"]),
        currentTvModalData() {
            return this.tvModalStack[this.tvModalStack.length - 1] || {};
        },
        canTvModalGoBack() {
            return this.tvModalStack.length > 1;
        },
        isTvModalOpen() {
            return this.tvModalStack.length > 0;
        },
        isTouchDevice() {
            return window.matchMedia("(pointer: coarse)").matches;
        },
    },
    methods: {
        // setanta statistic
        setAntaStatistic() {
            const videoEl = this.$refs.videoRef;
            if (!videoEl) return;
            const script = document.createElement("script");
            script.src =
                "https://static.streamhub.tv/analytics/streamhub-analytics.min.js";
            script.async = true;
            script.onload = () => {
                const partnerId = "your-partner-id";
                const analyticsId = "your-analytics-id";
                const playerId = this.$route.params.id;
                const isLive = true;
                const publicId = this.$route.params.id; // уникальный ID телеканала
                this.streamhub = new StreamhubAnalytics(
                    partnerId,
                    "https://stats.streamhub.io",
                    playerId,
                    isLive,
                    undefined,
                    analyticsId
                );

                // Если live — важно указать канал
                // this.streamhub.setChannelId(publicId);

                // onMediaReady обязательно
                this.streamhub.onMediaReady(publicId);

                setupListeners();
            };
            document.head.appendChild(script);
            const that = this;
            function setupListeners() {
                videoEl.addEventListener("play", () => {
                    if (that.firstPlay) {
                        that.streamhub.onMediaStart();
                        that.firstPlay = false;
                    }
                    that.streamhub.setPaused(false);
                });

                videoEl.addEventListener("pause", () => {
                    that.streamhub.setPaused(true);
                });

                videoEl.addEventListener("timeupdate", () => {
                    that.streamhub.onTick(Math.floor(videoEl.currentTime));
                });

                videoEl.addEventListener("ended", () => {
                    that.streamhub.onMediaComplete();
                });
            }
        },
        //
        selectedProgram() {
            const item = this.epg.find((item) => {
                if (item.id == this.timeDate.id) {
                    return item;
                }
            });
            if (item) {
                this.currentPrograName = item.name;
            }
        },
        // tvModal
        openTvModalModal(data) {
            if (this.tvModalStack && this.tvModalStack.length > 0) {
                this.tvModalStack.pop();
                return;
            }
            this.tvModalStack = [data]; // Открываем новую модалку
            clearTimeout(this.hideControlsTimeout);
            this.controlsVisible = true;
        },
        openTvModalItem(item) {
            if (item) {
                if (item.type === "complain_inner") {
                    this.setComplaint(item.id);
                }
                if (item.type === "language_inner") {
                    this.currentAudioTrack = item.item;
                    this.hlsInstance.audioTrack = item.item.id;
                }
                if (item.type === "complains") {
                    if (this.isProblemSended) {
                        this.isProblemSended = false;
                        this.isProblemWasSended = true;
                    }
                }
                this.goTvModalBack();
            }
            if (!item.list) return;
            this.tvModalStack.push(item);
        },
        goTvModalBack() {
            if (this.canTvModalGoBack) {
                this.tvModalStack.pop();
            }
        },
        closeTvModalModal() {
            this.tvModalStack = [];
        },
        // tvModal
        setComplaint(id) {
            const body = { ...this.forProblemsInfo, problem_id: id };
            this.$store.dispatch("setComplains", {
                body,
                movieType: "channel",
            });

            this.isProblemWasSended = false;
            this.isProblemSended = true;
            clearTimeout(this.isProblemSendedInteval);
            this.isProblemSendedInteval = setTimeout(() => {
                this.isProblemSended = false;
                this.isProblemWasSended = true;
            }, 2000);
        },
        ...mapActions(["fetchComplains"]),
        toggleTvprogram(id) {
            this.$emit("toggleTvprogram", id);
        },
        loadHls(hlsSource) {
            const video = this.$refs.videoRef;

            if (!hlsSource) {
                this.isPlay = false;
                this.hlsInstance.detachMedia();
                this.hlsInstance.destroy();
                this.hlsInstance = null;
                return;
            }

            if (Hls.isSupported()) {
                if (this.hlsInstance) {
                    this.hlsInstance.destroy();
                }
                const HLS = new Hls();
                this.hlsInstance = HLS;
                HLS.on(Hls.Events.MANIFEST_PARSED, (event, data) => {
                    HLS.startLevel = data.levels.length - 1;
                    this.checkAudioTracks(data.audioTracks);
                });
                HLS.on(Hls.Events.ERROR, (event, data) => {
                    if (data.fatal) {
                        switch (data.type) {
                            case Hls.ErrorTypes.NETWORK_ERROR:
                                this.errorHlsCount++;
                                if (this.errorHlsCount < 5) {
                                    hls.startLoad();
                                    return;
                                }
                                console.log(
                                    "fatal network error encountered, try to recover"
                                );
                                if (data?.response?.code === 404) {
                                    hls.destroy();
                                    return;
                                }
                                hls.startLoad();
                                break;
                            case Hls.ErrorTypes.MEDIA_ERROR:
                                console.log(
                                    "Media error, trying to recover..."
                                );
                                this.hlsInstance.recoverMediaError();
                                break;
                            default:
                                console.log(
                                    "Unrecoverable error, reloading HLS..."
                                );
                                this.loadHls(hlsSource);
                        }
                    }
                });
                // Обработчик события изменения фрагмента
                HLS.on(Hls.Events.FRAG_CHANGED, (event, data) => {
                    if (!this.startPTS) {
                        this.startPTS = Math.round(data.frag.startPTS) * 1000;
                    }
                    if (this.startPTS === 0) {
                        this.stopedTime = data.frag.programDateTime;
                    } else {
                        this.stopedTime =
                            data.frag.programDateTime - this.startPTS;
                    }
                });

                HLS.loadSource(hlsSource);
                HLS.attachMedia(video);
                video.play();
                HLS.startLoad();
            } else {
                video.src = hlsSource;
            }
        },
        checkAudioTracks(audioTracks) {
            if (!Array.isArray(audioTracks) || audioTracks.length === 0) {
                const audioTracks = this.tvModal.list.find(
                    (item) => item.type === "language"
                );
                if (audioTracks) {
                    this.tvModal.list.splice(
                        this.tvModal.list.indexOf(audioTracks),
                        1
                    );
                }
                return;
            }
            const filteredTracks = [];

            audioTracks.forEach((el) => {
                // if (!el.lang) return;
                filteredTracks.push(el);
            });

            const langs = {
                title_ru: this.$t("message.tvChannel.audioTracks"),
                title_uz: this.$t("message.tvChannel.audioTracks"),
                type: "language",
                list: filteredTracks.map((item) => {
                    return {
                        title_ru: this.checkLangname(item),
                        title_uz: this.checkLangname(item),
                        type: "language_inner",
                        id: item.lang,
                        item: item,
                    };
                }),
            };

            if (this.tvModal.list.length > 0) {
                const audioTracks = this.tvModal.list.find(
                    (item) => item.type === "language"
                );
                if (audioTracks) {
                    this.tvModal.list.splice(
                        this.tvModal.list.indexOf(audioTracks),
                        1
                    );
                }
            }
            this.tvModal.list.push(langs);
            this.currentAudioTrack = filteredTracks[0];
        },
        checkLangname(item) {
            let current;
            current = item.lang ? item.lang : item.name;
            current = current.replace("undefined", "").trim();
            return current;
        },
        toggleFullScreen() {
            if (this.userAgent === "iPhone") {
                this.$refs.videoRef.webkitEnterFullScreen();
                return;
            }
            this.$emit("toggleFullScreen");
            this.showControlsPrevent();
        },
        togglePlay() {
            const video = this.$refs.videoRef;
            if (video.paused) {
                video.play();
                this.hlsInstance.startLoad();
            } else {
                video.pause();
                this.isLive = false;
                this.hlsInstance.stopLoad();
            }
            this.showControlsPrevent();
        },
        videoPlayHandler() {
            this.isPlaying = true;
        },
        videoPauseHandler() {
            this.isPlaying = false;
        },
        goBack() {
            if (!window.history.state.back) {
                this.$router.push({ name: "home" });
                return;
            }
            this.$router.go(-1);
        },
        liveToggle() {
            if (this.isLive) return;
            this.isLive = true;
            this.liveTime = +(Date.now() / 1000).toFixed();
            this.$emit("getLive");
            this.showControlsPrevent();
        },
        togglePlayFromVideo() {
            if (this.isTvModalOpen) {
                this.closeTvModalModal();
                return;
            }
            if (this.isTouchDevice) {
                this.controlsVisible = false;
                return;
            }
            this.clickCount++;
            if (this.clickCount === 1) {
                this.clickTimeout = setTimeout(() => {
                    this.togglePlay();
                    this.clickCount = 0;
                }, 300);
            } else {
                clearTimeout(this.clickTimeout);
                this.toggleFullScreen();
                this.clickCount = 0;
            }
        },
        seekVideoHandler(rewindTime) {
            const currentTimeSeconds = +(Date.now() / 1000).toFixed();
            if (rewindTime > currentTimeSeconds) {
                this.timeConverter(currentTimeSeconds);
                this.isLive = true;
                this.liveTime = +(Date.now() / 1000).toFixed();
                this.$emit("getLive");
            } else {
                // this.togglePlay();
                this.isLive = false;
                this.stopedTime = rewindTime * 1000;
                this.liveTime = +rewindTime;
                this.timeConverter(+rewindTime);
                // this.togglePlay();

                this.$emit(
                    "seekVideo",
                    this.currentProgramTime?.id,
                    +rewindTime
                );
            }
            if (this.isTouchDevice) {
                this.showControlsPrevent();
            }
        },
        timeConverter(timeSeconds) {
            this.programTime.beginTime = converter(
                Number(timeSeconds)
            ).toString();
        },
        showControls(e) {
            if (this.isTvModalOpen) {
                if (this.isTouchDevice) {
                    this.goTvModalBack();
                }
                return;
            }

            if (this.isTouchDevice) {
                if (!e) {
                    this.showControlsPrevent();
                    return;
                }
                if (e.type === "mousemove") {
                    return;
                }
                if (this.controlsVisible) {
                    return;
                }
            }
            clearTimeout(this.hideControlsTimeout);
            this.controlsVisible = true;
            this.hideControlsTimeout = setTimeout(() => {
                this.controlsVisible = false;
            }, this.hideControlsDelay);
        },
        showControlsPrevent(e) {
            clearTimeout(this.hideControlsTimeout);
            this.controlsVisible = true;
            this.hideControlsTimeout = setTimeout(() => {
                this.controlsVisible = false;
            }, this.hideControlsDelay);
        },
        hideControls() {
            if (this.isTvModalOpen) {
                return;
            }
            clearTimeout(this.hideControlsTimeout);
            this.hideControlsTimeout = setTimeout(() => {
                this.controlsVisible = false;
            }, this.hideControlsDelay);
        },
        hideControlsPrevent() {
            clearTimeout(this.hideControlsTimeout);

            this.hideControlsTimeout = setTimeout(() => {
                this.controlsVisible = false;
            }, this.hideControlsDelay);
        },
        async toggleWindow() {
            const video = this.$refs.videoRef;
            if (document.pictureInPictureElement) {
                document.exitPictureInPicture();
            } else if (document.pictureInPictureEnabled) {
                if (document.fullscreenElement) {
                    await document.exitFullscreen();
                }
                await video.requestPictureInPicture();
            }
            this.showControlsPrevent();
        },
        videTimeUpdateHandler(e) {
            if (!e) return;
            const { currentTime, duration } = e.target;
            if (!this.currentProgramTime) return;
            const { beginTime, endTime } = this.currentProgramTime;
            if (this.lastUpdateTime !== currentTime.toFixed()) {
                this.lastUpdateTime = currentTime.toFixed();
                this.liveTime += 1;

                this.timeConverter(this.liveTime);

                if (this.liveTime === endTime) this.nextProgram();
            }
        },
        nextProgram() {
            this.showControlsPrevent();
            if (this.isLive) return;
            if (!this.currentProgramTime) return;
            const { beginTime, endTime } = this.currentProgramTime;

            const currentTimeSeconds = +(Date.now() / 1000).toFixed();

            if (endTime > currentTimeSeconds) {
                this.isLive = true;
                this.liveTime = +currentTimeSeconds;

                this.liveToggle();
                return;
            }

            this.$emit("nextProgram");
        },
        prevTime() {
            this.showControlsPrevent();
            this.$emit("prevTime");
        },
        nextTime() {
            this.showControlsPrevent();
            this.$emit("nextTime");
        },
        prevChannel() {
            this.showControlsPrevent();
            this.$emit("prevChannel");
        },

        nextChannel() {
            this.showControlsPrevent();
            this.$emit("nextChannel");
        },
        changeVolume(e) {
            if (this.muted) {
                this.muted = false;
                this.$refs.videoRef.muted = false;
            }
            const val = e.target.value;
            this.volume = +val;
            this.$refs.videoRef.volume = +val / 100;
            if (this.volume === 0) {
                this.muted = true;
                this.$refs.videoRef.muted = true;
            }
            this.showControlsPrevent();
        },
        toggleMuted() {
            this.muted = !this.muted;
            if (!this.muted) {
                this.$refs.videoRef.volume = 1;
                this.volume = 100;
            } else {
                this.$refs.videoRef.volume = 0;
                this.volume = 0;
            }
            this.$refs.videoRef.muted = this.muted;
            this.showControlsPrevent();
        },
        async toggleLike(chanel) {
            this.showControlsPrevent();
            if (!chanel) return;
            if (chanel.is_favorited === 0) {
                await favouriteChannel("like", chanel.id);
                this.$store.commit("SET_STATIC_FAVOURITE", chanel.id);
                this.isLiked = true;
            } else {
                await favouriteChannel("dislike", chanel.id);
                this.$store.commit("REMOVE_STATIC_FAVOURITE", chanel.id);
                this.isLiked = false;
            }
            this.$store.commit("SET_FAVORITED_CHANELS", chanel.id);
        },
        controlFromkeyBoard(e) {
            // Показываем элементы управления
            this.showControls(e);
            // Проверяем, запрещён ли доступ
            if (this.notAcces) return;
            // Исключаем повторные срабатывания при зажатии клавиши
            if (e.repeat) return;

            switch (e.code) {
                case "ArrowUp":
                    this.nextChannel();
                    break;
                case "ArrowDown":
                    this.prevChannel();
                    break;
                case "ArrowLeft":
                    this.prevTime();
                    break;
                case "ArrowRight":
                    this.nextTime();
                    break;
                case "KeyF":
                    this.toggleFullScreen();
                    break;
                case "Enter":
                    this.togglePlay();
                    break;
                case "KeyT":
                    this.toggleTvprogram(1);
                    break;
                case "KeyA":
                    this.toggleLike(this.currentItem);
                    break;
                case "Space":
                    e.preventDefault(); // Предотвращает прокрутку страницы
                    this.togglePlay();
                    break;
                case "KeyM":
                    this.toggleMuted();
                    break;
                case "KeyK":
                    this.toggleWindow();
                    break;
                case "KeyL":
                    this.liveToggle();
                    break;
                case "KeyP":
                    this.toggleTvprogram(2);
                    break;
                case "KeyS":
                    this.openTvModalModal(this.tvModal);
                    break;
            }
        },

        closeLeftPanel() {
            this.$emit("closeLeftPanel");
        },
    },
    beforeUnmount() {
        if (this.hlsInstance) {
            this.hlsInstance.destroy();
            this.hlsInstance.detachMedia();
            this.hlsInstance = null;
        }
        this.startPTS = null;
        this.isPlayStarted = false;
        window.removeEventListener("keydown", this.controlFromkeyBoard);
    },
    created() {
        this.fetchComplains("channel");
    },
    mounted() {
        clearTimeout(this.hideControlsTimeout);
        this.controlsVisible = true;
        window.addEventListener("keydown", this.controlFromkeyBoard);
        // this.setAntaStatistic();
        // try {
        // } catch (error) {
        //     console.log(error);
        // }
    },
};
</script>

<style lang="scss">
@import "./styles/index.scss";
</style>
